"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SVBApiDetailsContactUs = props => {
  var _props$contacts, _props$title, _props$subTitle;
  const contacts = (_props$contacts = props === null || props === void 0 ? void 0 : props.contacts) !== null && _props$contacts !== void 0 ? _props$contacts : [];
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "For further details on API Registration reach out to the below contact.";
  const subTitle = (_props$subTitle = props === null || props === void 0 ? void 0 : props.subTitle) !== null && _props$subTitle !== void 0 ? _props$subTitle : "Pod/Team Name";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row p-3 svb-tag_status-tag_info"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph mb-0"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph mb-0"
  }, subTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, contacts === null || contacts === void 0 ? void 0 : contacts.map((item, index) => {
    var _item$contacts;
    return /*#__PURE__*/_react.default.createElement("p", {
      key: index,
      className: "paragraph mb-0"
    }, /*#__PURE__*/_react.default.createElement("b", null, item.title, ":"), " ", item === null || item === void 0 || (_item$contacts = item.contacts) === null || _item$contacts === void 0 ? void 0 : _item$contacts.map((i, ind) => {
      return /*#__PURE__*/_react.default.createElement("a", {
        key: i,
        href: "#"
      }, " ", i, ";");
    }), " ");
  })));
};
var _default = SVBApiDetailsContactUs;
exports.default = _default;